<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<p class="ded" style="margin-top:3em">For Brandon and Holly Robison,<br/>my nephew and niece, who have<br/>starred in some of my earlier works,<br/>including such classics as <i>A Very<br/>Zombie Christmas</i></p>
<p class="ded1">Special thanks to April Murray for<br/>her insightful review to ensure a<br/>respectful portrayal of the<br/>Maasai people</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?793ccbfe